export default __webpack_public_path__ + "static/media/mic.6c30b8de.svg";